import { render, staticRenderFns } from "./SelectedItemsBar.vue?vue&type=template&id=d229de34"
import script from "./SelectedItemsBar.vue?vue&type=script&lang=js"
export * from "./SelectedItemsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports